<template>
    <div class="subAccountList">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="员工管理" name="staffMag">
                <staff-mag-list></staff-mag-list>
            </el-tab-pane>
            <el-tab-pane label="角色管理" name="roleMag">
                <role-mag></role-mag>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import staffMagList from './StaffMagList'
import roleMag from './RoleMag'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'subAccount',
    data() {
        return {
            activeName: 'staffMag'
        }
    },
    mounted() {
        if (this.params.subAccount && this.params.subAccount.activeName) {
            this.activeName = this.params.subAccount.activeName
        } else {
            this.setParams({subAccount: {activeName: this.activeName}})
        }
        if (this.$route.params.tab) {
            this.activeName = this.$route.params.tab
        }
    },
    methods: {
        handleClick(tab, event) {
            this.setParams({activeName: tab.name})
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'params'
        ])
    },
    components: {
        staffMagList, roleMag
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .subAccountList {
    }
</style>
